import React, { useState } from "react";
import { Card, Table, Form, Button, Dropdown } from "react-bootstrap";
import { FiEye, FiTrash2, FiCalendar } from "react-icons/fi";
import DeleteModal from "../../modals/domain-modals/DeleteModal";
import DomainDetailModal from "../../modals/domain-modals/DomainDetailModal";
// import DomainDetailModal from "../components/DomainDetailModal";
// import DeleteModal from "../components/DeleteModal";
import { CiCalendarDate } from "react-icons/ci";

const DomainList = ({ plans: propPlans, setPlans: setPropPlans }) => {
  const [showDetail, setShowDetail] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);

  const [domains, setDomains] = useState([
    {
      id: 1,
      name: "BrightWave Innovations",
      logo: "/assets/img/company/company-01.svg",
      url: "bwi.example.com",
      plan: "Advanced (Monthly)",
      planName: "Advanced",
      planType: "Monthly",
      price: 200,
      created: "12 Sep 2024",
      expire: "11 Oct 2024",
      status: "Approved",
    },
    {
      id: 2,
      name: "Stellar Dynamics",
      logo: "/assets/img/company/company-02.svg",
      url: "sd.example.com",
      plan: "Basic (Yearly)",
      planName: "Basic",
      planType: "Yearly",
      price: 120,
      created: "24 Oct 2024",
      expire: "24 Oct 2025",
      status: "Pending",
    },
    {
      id: 3,
      name: "Quantum Nexus",
      logo: "/assets/img/company/company-03.svg",
      url: "qn.example.com",
      plan: "Advanced (Monthly)",
      planName: "Advanced",
      planType: "Monthly",
      price: 200,
      created: "18 Feb 2024",
      expire: "18 Mar 2024",
      status: "Rejected",
    },
    {
      id: 1,
      name: "BrightWave Innovations",
      logo: "/assets/img/company/company-04.svg",
      url: "bwi.example.com",
      plan: "Advanced (Monthly)",
      planName: "Advanced",
      planType: "Monthly",
      price: 200,
      created: "12 Sep 2024",
      expire: "11 Oct 2024",
      status: "Approved",
    },
    {
      id: 2,
      name: "Stellar Dynamics",
      logo: "/assets/img/company/company-05.svg",
      url: "sd.example.com",
      plan: "Basic (Yearly)",
      planName: "Basic",
      planType: "Yearly",
      price: 120,
      created: "24 Oct 2024",
      expire: "24 Oct 2025",
      status: "Pending",
    },
    {
      id: 3,
      name: "Quantum Nexus",
      logo: "/assets/img/company/company-06.svg",
      url: "qn.example.com",
      plan: "Advanced (Monthly)",
      planName: "Advanced",
      planType: "Monthly",
      price: 200,
      created: "18 Feb 2024",
      expire: "18 Mar 2024",
      status: "Rejected",
    },
    {
      id: 1,
      name: "BrightWave Innovations",
      logo: "/assets/img/company/company-07.svg",
      url: "bwi.example.com",
      plan: "Advanced (Monthly)",
      planName: "Advanced",
      planType: "Monthly",
      price: 200,
      created: "12 Sep 2024",
      expire: "11 Oct 2024",
      status: "Approved",
    },
    {
      id: 2,
      name: "Stellar Dynamics",
      logo: "/assets/img/company/company-08.svg",
      url: "sd.example.com",
      plan: "Basic (Yearly)",
      planName: "Basic",
      planType: "Yearly",
      price: 120,
      created: "24 Oct 2024",
      expire: "24 Oct 2025",
      status: "Pending",
    },
  ]);

  const openDetail = (domain) => {
    setSelectedDomain(domain);
    setShowDetail(true);
  };

  const openDelete = (domain) => {
    setSelectedDomain(domain);
    setShowDelete(true);
  };

  const deleteDomain = () => {
    setDomains(domains.filter((d) => d.id !== selectedDomain.id));
    setShowDelete(false);
  };

  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const plans = propPlans || domains;
  const setPlans = setPropPlans || setDomains;

    const filteredPlans = plans.filter((plan) =>
    plan.name.toLowerCase().includes(search.toLowerCase()),
  );

  /* ROW LIMIT */

  const displayedPlans = filteredPlans.slice(0, rowsPerPage);

  return (
    <Card style={{ border: "1px solid #eee",backgroundColor:"rgb(255 255 255)" }}>
      <Card.Header
        className="d-flex justify-content-between align-items-center flex-wrap"
        style={{ padding: "14px 18px",backgroundColor:"rgb(255 255 255)" }}
      >
        <h5 style={{ fontWeight: "600", margin: 0 }}>Domain List</h5>

        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {/* Date Dropdown */}
          <Dropdown>
            <Dropdown.Toggle
              style={{
                height: "40px",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                background: "#fff",
                color: "#111",
                fontSize: "14px",
                padding: "6px 14px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <CiCalendarDate style={{ fontSize: "20px" }} /> 02/28/2026 -
              03/06/2026
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                borderRadius: "8px",
                padding: "6px 0",
                border: "1px solid #eee",
                fontSize: "14px",
              }}
            >
              {[
                "Today",
                "Yesterday",
                "Last 7 Days",
                "Last 30 Days",
                "This Year",
                "Next Year",
                "Custom Range",
              ].map((item) => (
                <Dropdown.Item
                  key={item}
                  style={{
                    padding: "8px 16px",
                    transition: "0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#f26522";
                    e.target.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    if (item !== "Last 7 Days") {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#333";
                    }
                  }}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          {/* Select Plan */}
          <Dropdown>
            <Dropdown.Toggle
              style={{
                height: "40px",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                background: "#fff",
                color: "#111",
                fontSize: "14px",
                padding: "6px 14px",
              }}
            >
              Select Plan
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ borderRadius: "8px" }}>
              {["Monthly", "Yearly"].map((item) => (
                <Dropdown.Item
                  key={item}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#f26522";
                    e.target.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "";
                    e.target.style.color = "";
                  }}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          {/* Select Status */}
          <Dropdown>
            <Dropdown.Toggle
              style={{
                height: "40px",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                background: "#fff",
                color: "#111",
                fontSize: "14px",
                padding: "6px 14px",
              }}
            >
              Select Status
            </Dropdown.Toggle>

            <Dropdown.Menu className="p-3" style={{ borderRadius: "8px" }}>
              {["Approved", "Pending","Rejected"].map((item) => (
                <Dropdown.Item
                  key={item}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#f26522";
                    e.target.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "";
                    e.target.style.color = "";
                  }}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          {/* Sort */}
          <Dropdown>
            <Dropdown.Toggle
              style={{
                height: "40px",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                background: "#fff",
                color: "#111",
                fontSize: "14px",
                padding: "6px 14px",
              }}
            >
              Sort By : Last 7 Days
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ borderRadius: "8px" }}>
              {[
                "Recently Added",
                "Ascending",
                "Descending",
                "Last Month",
                "Last 7 Days",
              ].map((item) => (
                <Dropdown.Item
                  key={item}
                  style={
                    item === "Last 7 Days"
                      ? { background: "#f26522", color: "#fff" }
                      : {}
                  }
                  onMouseEnter={(e) => {
                    e.target.style.background = "#f26522";
                    e.target.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    if (item !== "Last 7 Days") {
                      e.target.style.background = "";
                      e.target.style.color = "";
                    }
                  }}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Card.Header>

      <div className="d-flex justify-content-between align-items-center p-3 flex-wrap">
        <div className="d-flex align-items-center gap-2">
          <span>Row Per Page</span>

          <Form.Select
            style={{ width: "80px" }}
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </Form.Select>

          <span>Entries</span>
        </div>

        <Form.Control
          type="text"
          placeholder="Search"
          style={{ width: "220px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Card.Body style={{ padding: 0 }}>
        <Table responsive hover>
          <thead style={{ background: "#f6f7fb" }}>
            <tr>
              <th>
                <Form.Check type="checkbox" />
              </th>
              <th>Name</th>
              <th>Domain URL</th>
              <th>Plan</th>
              <th>Created Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {domains.map((domain) => (
              <tr key={domain.id}>
                <td>
                  <Form.Check type="checkbox" />
                </td>

                <td>
                  <div className="d-flex align-items-center">
                    <img
                      src={domain.logo}
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        border: "1px solid #eee",
                        padding: "6px",
                      }}
                    />

                    <div style={{ marginLeft: "10px" }}>
                      <span style={{ fontWeight: 500 }}>{domain.name}</span>
                    </div>
                  </div>
                </td>

                <td>{domain.url}</td>

                <td>{domain.plan}</td>

                <td>{domain.created}</td>

                <td>
                  {domain.status === "Approved" && (
                    <span className="badge bg-success-subtle text-success">
                      Approved
                    </span>
                  )}

                  {domain.status === "Pending" && (
                    <span className="badge bg-info-subtle text-info">
                      Pending
                    </span>
                  )}

                  {domain.status === "Rejected" && (
                    <span className="badge bg-danger-subtle text-danger">
                      Rejected
                    </span>
                  )}
                </td>

                <td>
                  <div className="d-flex gap-3">
                    <FiEye
                      style={{ cursor: "pointer" }}
                      onClick={() => openDetail(domain)}
                    />

                    <FiTrash2
                      style={{ cursor: "pointer" }}
                      onClick={() => openDelete(domain)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>

      {/* MODALS */}

      <DomainDetailModal
        show={showDetail}
        handleClose={() => setShowDetail(false)}
        domain={selectedDomain}
      />

      <DeleteModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        deleteDomain={deleteDomain}
      />
    </Card>
  );
};

export default DomainList;
